













































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import PricePo from "@/store/entities/finance/pricepo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
class pricedetailpo {
  name: string;
  dailyprice: number; //日常基础价格
  daylyserviceprice: number; //日常服务价格
  sewageprice: number; //排污价格
  summerprice: number; //夏季基础价格
  summerserviceprice: number; //夏季服务价格
  num: number; //阶梯量
}

@Component({
  components: { TreeSelect },
})
export default class EditPrice extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "1" }) iteminfo: string;
  pricepo: PricePo = new PricePo();
  isAble: boolean = true;
  columns: any[] = [];
  columnsdata: any[] = [];
  pricedetailpo = new pricedetailpo();

  async created() {
    this.meterTypeDetail();
    await this.areaTree();
  }
  //添加尖峰平谷
  addPeakPinggu(data: PricePo) {
    this.columnsdata = [];
    if (data == null) {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Tip");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Peak");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Flat");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Valley");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
    } else {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Tip");
      this.pricedetailpo.num = data.secondNum;
      this.pricedetailpo.dailyprice = data.secondBasePrice;
      this.pricedetailpo.daylyserviceprice = data.secondSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerSecondPrice;
      this.pricedetailpo.summerserviceprice = data.summerSecondServicePrice;
      this.pricedetailpo.sewageprice = data.firstSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Peak");
      this.pricedetailpo.num = data.thirdNum;
      this.pricedetailpo.dailyprice = data.thirdBasePrice;
      this.pricedetailpo.daylyserviceprice = data.thirdSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerThirdPrice;
      this.pricedetailpo.summerserviceprice = data.summerThirdServicePrice;
      this.pricedetailpo.sewageprice = data.thirdSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Flat");
      this.pricedetailpo.num = data.firstNum;
      this.pricedetailpo.dailyprice = data.firstBasePrice;
      this.pricedetailpo.daylyserviceprice = data.firstSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerFirstPrice;
      this.pricedetailpo.summerserviceprice = data.summerFirstServicePrice;
      this.pricedetailpo.sewageprice = data.firstSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("Valley");
      this.pricedetailpo.num = data.fourNum;
      this.pricedetailpo.dailyprice = data.fourBasePrice;
      this.pricedetailpo.daylyserviceprice = data.fourSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerFourPrice;
      this.pricedetailpo.summerserviceprice = data.summerFourServicePrice;
      this.pricedetailpo.sewageprice = data.fourSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
    }
  }
  //添加固定单价
  addfiexd(data: PricePo) {
    this.columnsdata = [];
    if (data == null) {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FixedPrice");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
    } else {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FixedPrice");
      this.pricedetailpo.dailyprice = data.firstBasePrice;
      this.pricedetailpo.daylyserviceprice = data.firstSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerFirstPrice;
      this.pricedetailpo.summerserviceprice = data.summerFirstServicePrice;
      this.pricedetailpo.sewageprice = data.firstSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
    }
  }
  //添加阶梯单价
  addstepprice(data: PricePo) {
    this.columnsdata = [];
    if (data == null) {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FirstStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("SecondStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("ThirdStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FourStep");
      this.pricedetailpo.dailyprice = 0;
      this.pricedetailpo.daylyserviceprice = 0;
      this.pricedetailpo.num = 0;
      this.pricedetailpo.summerprice = 0;
      this.pricedetailpo.summerserviceprice = 0;
      this.pricedetailpo.sewageprice = 0;
      this.columnsdata.push(this.pricedetailpo);
    } else {
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FirstStep");
      this.pricedetailpo.num = data.firstNum;
      this.pricedetailpo.dailyprice = data.firstBasePrice;
      this.pricedetailpo.daylyserviceprice = data.firstSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerFirstPrice;
      this.pricedetailpo.summerserviceprice = data.summerFirstServicePrice;
      this.pricedetailpo.sewageprice = data.firstSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("SecondStep");
      this.pricedetailpo.num = data.secondNum;
      this.pricedetailpo.dailyprice = data.secondBasePrice;
      this.pricedetailpo.daylyserviceprice = data.secondSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerSecondPrice;
      this.pricedetailpo.summerserviceprice = data.summerSecondServicePrice;
      this.pricedetailpo.sewageprice = data.firstSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("ThirdStep");
      this.pricedetailpo.num = data.thirdNum;
      this.pricedetailpo.dailyprice = data.thirdBasePrice;
      this.pricedetailpo.daylyserviceprice = data.thirdSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerThirdPrice;
      this.pricedetailpo.summerserviceprice = data.summerThirdServicePrice;
      this.pricedetailpo.sewageprice = data.thirdSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
      this.pricedetailpo = new pricedetailpo();
      this.pricedetailpo.name = this.L("FourStep");
      this.pricedetailpo.num = data.fourNum;
      this.pricedetailpo.dailyprice = data.fourBasePrice;
      this.pricedetailpo.daylyserviceprice = data.fourSyntheticalPrice;
      this.pricedetailpo.summerprice = data.summerFourPrice;
      this.pricedetailpo.summerserviceprice = data.summerFourServicePrice;
      this.pricedetailpo.sewageprice = data.fourSewagePrice;
      this.columnsdata.push(this.pricedetailpo);
    }
  }
  //正常列
  columnlist = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("Daily"),
      align: "center",
      children: [
        {
          title: this.L("Daily"),
          key: "dailyprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.dailyprice,
              },
              domProps: {
                value: params.row.dailyprice,
              },
              on: {
                input: function (event) {
                  self.changeStepBasePrice(params.index, event);
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "daylyserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.daylyserviceprice,
              },
              domProps: {
                value: params.row.daylyserviceprice,
              },
              on: {
                input: function (event) {
                  self.changeStepBaseService(params.index, event);
                },
              },
            });
          },
        },
      ],
    },
    {
      title: this.L("SummerPrice"),
      align: "center",
      children: [
        {
          title: this.L("SummerPrice"),
          key: "summerprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerprice,
              },
              domProps: {
                value: params.row.summerprice,
              },
              on: {
                input: function (event) {
                  self.changeStepSummerBasePrice(params.index, event);
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "summerserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerserviceprice,
              },
              domProps: {
                value: params.row.summerserviceprice,
              },
              on: {
                input: function (event) {
                  self.changeStepSummerBaseService(params.index, event);
                },
              },
            });
          },
        },
      ],
    },
  ];
  //水表列
  watercolumnslist = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("Daily"),
      key: "dailyprice",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.dailyprice,
          },
          domProps: {
            value: params.row.dailyprice,
          },
          on: {
            input: function (event) {
              self.changeStepBasePrice(params.index, event);
            },
          },
        });
      },
    },
    {
      title: this.L("SewagePrice"),
      key: "sewageprice",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.sewageprice,
          },
          domProps: {
            value: params.row.sewageprice,
          },
          on: {
            input: function (event) {
              self.changeSewagePrice(params.index, event);
            },
          },
        });
      },
    },
    {
      title: this.L("ServiceCharge"),
      key: "daylyserviceprice",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.daylyserviceprice,
          },
          domProps: {
            value: params.row.daylyserviceprice,
          },
          on: {
            input: function (event) {
              self.changeStepBaseService(params.index, event);
            },
          },
        });
      },
    },
  ];
  //阶梯
  stepcolumnlist = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("StepNum"),
      key: "num",
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.num,
          },
          domProps: {
            value: params.row.num,
          },
          on: {
            input: function (event) {
              self.changeStepUseValue(params.index, event);
            },
          },
        });
      },
    },
    {
      title: this.L("Daily"),
      align: "center",
      children: [
        {
          title: this.L("Daily"),
          key: "dailyprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.dailyprice,
              },
              domProps: {
                value: params.row.dailyprice,
              },
              on: {
                input: function (event) {
                  self.changeStepBasePrice(params.index, event);
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "daylyserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.daylyserviceprice,
              },
              domProps: {
                value: params.row.daylyserviceprice,
              },
              on: {
                input: function (event) {
                  self.changeStepBaseService(params.index, event);
                },
              },
            });
          },
        },
      ],
    },
    {
      title: this.L("SummerPrice"),
      align: "center",
      children: [
        {
          title: this.L("SummerPrice"),
          key: "summerprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerprice,
              },
              domProps: {
                value: params.row.summerprice,
              },
              on: {
                input: function (event) {
                  self.changeStepSummerBasePrice(params.index, event);
                },
              },
            });
          },
        },
        {
          title: this.L("ServiceCharge"),
          key: "summerserviceprice",
          render: (h: any, params: any) => {
            let self = this;
            return h("Input", {
              props: {
                value: params.row.summerserviceprice,
              },
              domProps: {
                value: params.row.summerserviceprice,
              },
              on: {
                input: function (event) {
                  self.changeStepSummerBaseService(params.index, event);
                },
              },
            });
          },
        },
      ],
    },
  ];
  //改变阶梯使用量
  changeStepUseValue(index: number, event: any) {
    if (this.pricepo.priceType == 2) {
      //阶梯
      if (index == 0) {
        this.pricepo.firstNum = event;
      } else if (index == 1) {
        this.pricepo.secondNum = event;
      } else if (index == 2) {
        this.pricepo.thirdNum = event;
      } else if (index == 3) {
        this.pricepo.fourNum = event;
      }
    }
  }
  //改变日常单价
  changeStepBasePrice(index: number, event: number) {
    if (this.pricepo.priceType == 0) {
      //固定
      this.pricepo.firstBasePrice = event;
    } else if (this.pricepo.priceType == 1) {
      //尖峰平谷
      if (index == 0) {
        this.pricepo.secondBasePrice = event;
      } else if (index == 1) {
        this.pricepo.thirdBasePrice = event;
      } else if (index == 2) {
        this.pricepo.firstBasePrice = event;
      } else if (index == 3) {
        this.pricepo.fourBasePrice = event;
      }
    } else if (this.pricepo.priceType == 2) {
      //阶梯
      if (index == 0) {
        this.pricepo.firstBasePrice = event;
      } else if (index == 1) {
        this.pricepo.secondBasePrice = event;
      } else if (index == 2) {
        this.pricepo.thirdBasePrice = event;
      } else if (index == 3) {
        this.pricepo.fourBasePrice = event;
      }
    }
  }
  //改变日常服务收费
  changeStepBaseService(index: number, event: number) {
    if (this.pricepo.priceType == 0) {
      this.pricepo.firstSyntheticalPrice = event;
    } else if (this.pricepo.priceType == 1) {
      //尖峰平谷
      if (index == 0) {
        this.pricepo.secondSyntheticalPrice = event;
      } else if (index == 1) {
        this.pricepo.thirdSyntheticalPrice = event;
      } else if (index == 2) {
        this.pricepo.firstSyntheticalPrice = event;
      } else if (index == 3) {
        this.pricepo.fourSyntheticalPrice = event;
      }
    } else if (this.pricepo.priceType == 2) {
      //阶梯
      if (index == 0) {
        this.pricepo.firstSyntheticalPrice = event;
      } else if (index == 1) {
        this.pricepo.secondSyntheticalPrice = event;
      } else if (index == 2) {
        this.pricepo.thirdSyntheticalPrice = event;
      } else if (index == 3) {
        this.pricepo.fourSyntheticalPrice = event;
      }
    }
  }
  //改变夏季单价
  changeStepSummerBasePrice(index: number, event: number) {
    if (this.pricepo.priceType == 0) {
      //固定单价
      this.pricepo.summerFirstPrice = event;
    } else if (this.pricepo.priceType == 1) {
      //尖峰平谷
      if (index == 0) {
        this.pricepo.summerSecondPrice = event;
      } else if (index == 1) {
        this.pricepo.summerThirdPrice = event;
      } else if (index == 2) {
        this.pricepo.summerFirstPrice = event;
      } else if (index == 3) {
        this.pricepo.summerFourPrice = event;
      }
    } else if (this.pricepo.priceType == 2) {
      //阶梯价
      if (index == 0) {
        this.pricepo.summerFirstPrice = event;
      } else if (index == 1) {
        this.pricepo.summerSecondPrice = event;
      } else if (index == 2) {
        this.pricepo.summerThirdPrice = event;
      } else if (index == 3) {
        this.pricepo.summerFourPrice = event;
      }
    }
  }
  //改变夏季服务
  changeStepSummerBaseService(index: number, event: number) {
    if (this.pricepo.priceType == 0) {
      //固定夏季
      this.pricepo.summerFirstServicePrice = event;
    } else if (this.pricepo.priceType == 1) {
      //尖峰平谷夏季服务
      if (index == 0) {
        this.pricepo.summerSecondServicePrice = event;
      } else if (index == 1) {
        this.pricepo.summerThirdServicePrice = event;
      } else if (index == 2) {
        this.pricepo.summerFirstServicePrice = event;
      } else if (index == 3) {
        this.pricepo.summerFourServicePrice = event;
      }
    } else if (this.pricepo.priceType == 2) {
      //阶梯夏季服务
      if (index == 0) {
        this.pricepo.summerSecondServicePrice = event;
      } else if (index == 1) {
        this.pricepo.summerThirdServicePrice = event;
      } else if (index == 2) {
        this.pricepo.summerFirstServicePrice = event;
      } else if (index == 3) {
        this.pricepo.summerFourServicePrice = event;
      }
    }
  }
  //改变水表排污单价
  changeSewagePrice(index: number, event: number) {
    if (this.pricepo.priceType == 0) {
      //固定
      this.pricepo.firstSewagePrice = event;
    } else if (this.pricepo.priceType == 2) {
      //阶梯
      if (index == 0) {
        this.pricepo.firstSewagePrice = event;
      } else if (index == 1) {
        this.pricepo.secondSewagePrice = event;
      } else if (index == 2) {
        this.pricepo.thirdSewagePrice = event;
      } else if (index == 3) {
        this.pricepo.fourSewagePrice = event;
      }
    }
  }
  //修改表计类型
  changeMeterType(val: any) {
    //水表
    if (val == 22) {
      this.columns = this.watercolumnslist; //改成水表表格
      this.addfiexd(this.pricepo);
      this.pricepo.priceType = 0;
    } else {
      this.columns = this.columnlist; //改成常用表格
      this.pricepo.priceType = 0;
      this.addfiexd(this.pricepo);
    }
  }
  //修改价格类型改变
  changeDisplay(val: any) {
    if (this.pricepo.meterType == 22 && val == 1) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("WaterNoTipPeaking"),
      });
      return;
    }
    if (val == 0) {
      //固定
      this.columns = this.columnlist; //正常列信息
      this.addfiexd(this.pricepo);
      this.pricepo.cycle = 0;
      this.isAble = true; //周期是否可用
    } else if (val == 1) {
      //尖峰平谷
      this.addPeakPinggu(this.pricepo);
      this.columns = this.columnlist;
      this.pricepo.cycle = 0;
      this.isAble = true; //周期是否可用
    } else {
      //阶梯价格
      this.addstepprice(this.pricepo);
      this.columns = this.stepcolumnlist;
      this.pricepo.cycle = 1;
      this.isAble = false;
    }
  }
  create() { }
  //保存
  save() {
    (this.$refs.priceForm as any).validate(async (valid: boolean) => {
      if (this.pricepo.priceType == 2) {
        if (
          this.pricepo.firstNum == 0 ||
          this.pricepo.secondNum == 0 ||
          this.pricepo.thirdNum == 0 ||
          this.pricepo.fourNum == 0
        ) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("StepNumNoEmpty"),
          });
          return;
        }
        if (this.pricepo.firstNum > this.pricepo.secondNum) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("FirstMaxSecond"),
          });
          return;
        }
        if (this.pricepo.secondNum > this.pricepo.thirdNum) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("SecondMaxThird"),
          });
          return;
        }
        if (this.pricepo.thirdNum > this.pricepo.fourNum) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("ThirdMaxFour"),
          });
          return;
        }
      }
      if (this.pricepo.summerFirstPrice > 0) {
        this.pricepo.isSummer = true;
      } else {
        this.pricepo.isSummer = false;
      }
      if (valid) {
        await this.$store
          .dispatch({
            type: "price/update",
            data: this.pricepo,
          })
          .catch((err) => {
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        (this.$refs.priceForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  //退出
  cancel() {
    (this.$refs.priceForm as any).resetFields();
    this.$emit("input", false);
  }
  meterTypeDetail() {
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 7) {
          this.$data.meterTypedetail.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 8) {
          this.$data.useTypedetail.push({ label: ele.name, value: ele.id });
        }
      });
    }
  }
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.pricepo = Util.extend(true, {}, this.$store.state.price.pricesItems);
      if (this.pricepo.priceType == 0) {
        if (this.pricepo.meterType == 22) {
          this.columns = this.watercolumnslist;
        } else {
          this.columns = this.columnlist;
        }
        this.addfiexd(this.pricepo);
        this.isAble = true;
      } else if (this.pricepo.priceType == 1) {
        //尖峰平谷
        if (this.pricepo.meterType == 22) {
          this.columns = this.watercolumnslist;
        } else {
          this.columns = this.columnlist;
        }
        this.addPeakPinggu(this.pricepo);
        this.isAble = false;
      } else if (this.pricepo.priceType == 2) {
        //阶梯
        this.columns = this.stepcolumnlist;
        this.addstepprice(this.pricepo);
        this.isAble = false;
      }
    }
  }
  ruleValidate = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        type: "number",
        required: true,
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    meterType: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    priceType: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    basePrice: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    settlementStandard: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    cycle: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    unitname: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    unitnum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstnum: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstBasePrices: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstsewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    firstsynthetical: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondnum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondbase: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondsewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    secondsynthetical: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdnum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdbase: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdsewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    thirdsynthetical: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    fournum: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    fourbase: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    foursewage: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    foursynthetical: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    sortCode: [
      {
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      meterTypedetail: [],
      useTypedetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
